import React from 'react';
import { Field, Form } from 'redux-form';
import { withStyles } from 'material-ui';

import { required } from 'entoro-shared';
import PropTypes from 'prop-types';
import { FormControlLabel, FormHelperText } from 'material-ui/Form';
import MaterialCheckbox from 'material-ui/Checkbox';

import moment from 'moment';

const styles = () => ({
  container: {
    margin: '0 auto',
  },
  title: {
    fontSize: '16px',
    marginBottom: '10px',
  },
  subheading: {
    color: '#8c8c8c',
    fontWeight: '300',
    marginBottom: '10px',
  },
});

const Checkbox = ({ input, label, disabled, meta: { touched, error } }) => (
  <div style={{ float: 'left', maxWidth: '100%' }}>
    <FormControlLabel
      style={{
        textAlign: 'left',
        marginBottom: '15px',
        textTransform: 'capitalize',
      }}
      control={
        <MaterialCheckbox
          disabled={disabled}
          checked={Boolean(input.value)}
          onChange={input.onChange}
        />
      }
      label={
        <div>
          {label}
          {touched && error ? (
            <FormHelperText error>{error}</FormHelperText>
          ) : null}
        </div>
      }
    />
  </div>
);

Checkbox.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.node.isRequired,
  meta: PropTypes.object.isRequired,
  disabled: PropTypes.bool,
};

Checkbox.defaultProps = {
  disabled: false,
};

const SuitabilityQuestionRegCf = ({
  change,
  handleSubmit,
  initialValues,
  offer,
  investorUser,
}) => {
  let limitations = null;
  let investLimit = null;
  if (offer.typeOfOffer == 'REG_CF') {
    if (initialValues.networth < '107000' || initialValues.income < '107000') {
      limitations =
        (Math.max(
          Number(initialValues.networth),
          Number(initialValues.income)
        ) *
          5) /
        100;
      investLimit = new Intl.NumberFormat().format(limitations);
    }
    if (initialValues.networth > '107000' && initialValues.income > '107000') {
      limitations =
        (Math.max(
          Number(initialValues.networth),
          Number(initialValues.income)
        ) *
          10) /
        100;
      investLimit = new Intl.NumberFormat().format(limitations);
    }
  } else if (offer.typeOfOffer == 'REG_A') {
    limitations =
      (Math.max(Number(initialValues.networth), Number(initialValues.income)) *
        10) /
      100;
    investLimit = new Intl.NumberFormat().format(limitations);
  }
  return (
    <Form onSubmit={handleSubmit}>
      <div
        style={{
          float: 'left',
          maxWidth: '100%',
        }}
      >
        <Field
          component={Checkbox}
          validate={required}
          required
          name='question_one'
          label={`I understand early-stage businesses are very risky. I can afford to lose the entirety of all investments I make in ${offer.name}.`}
        />
        {investorUser.selectedOptionTypes !== 'YES' && (
          <Field
            component={Checkbox}
            validate={required}
            required
            name='question_two'
            label={`I affirm that, including this investment, the total sum of all money I have invested in Reg CF deals over the past 12 months on any platform or portal does not exceed  $${investLimit}.`}
          />
        )}
        <Field
          component={Checkbox}
          validate={required}
          required
          name='question_three'
          label={`I understand that my investment in ${offer.name} is not transferrable for 12 months, and beyond that, privately issued securities of this type are not easily re-sold. The lack of mature secondary markets or exchanges for these securities means that even if I do find a buyer - I may not be able to obtain a fair price, and that it can take years to realize a return`}
        />
        <Field
          component={Checkbox}
          validate={required}
          required
          name='question_four'
          label={`I understand that spreading the investment plan to make in ${offer.name} among multiple deals would diversify my risk.`}
        />
        <Field
          component={Checkbox}
          validate={required}
          required
          name='question_five'
          label={`I understand OfferBoard® does not offer investment advice. I am sufficiently financially sophisticated and educated to evaluate companies based on the materials provided, and to make independent investment decisions.`}
        />
        <Field
          component={Checkbox}
          validate={required}
          required
          name='question_six'
          label={` I understand that OfferBoard® and or its affiliated Broker-Dealer Entoro Securities, LLC will receive a cash fee of ${
            offer.cashFee ? offer.cashFee : 'N/A'
          }% of the proceeds and a ${
            offer.securitiesCommission
          }%   securities commission.`}
        />

        <Field
          component={Checkbox}
          validate={required}
          required
          name='question_seven'
          label={` I understand that I am responsible for any fees and/or charges associated with my choice of investment method.`}
        />
        <Field
          component={Checkbox}
          validate={required}
          required
          name='question_eight'
          label={` I understand that OfferBoard® and ${offer.name} may not maintain a relationship beyond the conclusion of this offering.`}
        />

        <Field
          component={Checkbox}
          validate={required}
          required
          name='question_nine'
          label={`I understand I have up to 48 hours before the close of the campaign on ${
            offer.closingDate
              ? moment(offer.closingDate).format('DD-MM-YYYY')
              : 'N/A'
          } to cancel my investment.`}
        />
        <Field
          component={Checkbox}
          validate={required}
          required
          name='question_ten'
          label={
            <div>
              <span>I agree to the </span>
              <a
                href='https://entoro.offerboard.com/terms'
                target='_blank'
                rel='noopener noreferrer'
              >
                Terms and Conditions
              </a>
              <span> and the </span>
              <a
                href='https://entoro.offerboard.com/privacy'
                target='_blank'
                rel='noopener noreferrer'
              >
                Privacy Policy.
              </a>
            </div>
          }
        />
      </div>

      <div className='full-line' />
      {/* <input
        type='submit'
        value='Save'
        disabled={disabled}
        className={`button-2 w-button ${disabled ? 'btn-disabled' : ':'}`}
      /> */}
      <br />
    </Form>
  );
};

export default withStyles(styles)(SuitabilityQuestionRegCf);



// WEBPACK FOOTER //
// ./src/components/OfferOverview/ReadyToInvestButton/PaymentProcess/PaymentProcessForm/SutabilityQuestionRegCf.js